var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.data),function(item,itemindex){return _c('v-chip',{key:itemindex,staticClass:"mr-2",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.filter_item_via_category(item)}}},[_c('v-icon',[_vm._v(" "+_vm._s(item.icon)+" ")]),_vm._v(" "+_vm._s(item.name)+" ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }